import React, { useState } from "react";
import PermissionsTable from "./permissions/PermissionsTable";
import { FiUnlock, FiUser } from "react-icons/fi";
import UsersTable from "./users/UsersTable";

const UsersAndPermissionsMain = () => {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className="h-[95vh] w-full text-text-primary-light dark:text-text-primary-dark p-4">
      <div className="flex flex-col gap-4 h-full">
        {/* Tab Navigation */}
        <div className="flex gap-4 border-b border-gray-300 dark:border-gray-700">
          <button
            onClick={() => setActiveTab("users")}
            className={`content-center items-center relative flex gap-1 text-sm p-2 transition-colors duration-300 ${
              activeTab === "users"
                ? "bg-panel-light dark:bg-panel-dark text-accent-light dark:text-accent-dark font-semibold"
                : "text-gray-500 dark:text-white hover:text-blue-600 font-medium"
            }`}
          >
            <FiUser size={20} /> Users
            {activeTab === "users" && (
              <span className="absolute inset-x-0 -bottom-1 h-[2px] bg-text-accent-light dark:bg-text-accent-dark transition-all duration-300"></span>
            )}
          </button>
          <button
            onClick={() => setActiveTab("permissions")}
            className={`relative flex content-center items-center gap-1 text-sm p-2 transition-colors duration-300 ${
              activeTab === "permissions"
                ? "bg-panel-light dark:bg-panel-dark text-accent-light dark:text-accent-dark font-semibold"
                : "text-gray-500 dark:text-white hover:text-blue-600 font-medium"
            }`}
          >
            <FiUnlock size={20} /> Permission groups
            {activeTab === "permissions" && (
              <span className="absolute inset-x-0 -bottom-1 h-[2px] bg-text-accent-light dark:bg-text-accent-dark transition-all duration-300"></span>
            )}
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "permissions" && <PermissionsTable />}
        {activeTab === "users" && <UsersTable />}
      </div>
    </div>
  );
};

export default UsersAndPermissionsMain;
